import { render } from "./PreorderCart.vue?vue&type=template&id=0d0974f4&scoped=true"
import script from "./PreorderCart.vue?vue&type=script&lang=js"
export * from "./PreorderCart.vue?vue&type=script&lang=js"

import "./PreorderCart.vue?vue&type=style&index=0&id=0d0974f4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d0974f4"]])

export default __exports__